import Api from '~/store/idonia-api/api'

export default {
  data () {
    return {
      isCaptchaRendered: false,
      recaptchaWidgetId: null
    }
  },

  created () {
    window.renderCaptcha = this.renderRecaptchaCallback.bind(this)
  },

  async mounted () {
    if (this.recaptchaKey.length > 0) {
      await this.renderCaptcha()
    }
  },

  computed: {
    recaptchaKey () {
      return (this.$config && this.$config.recaptchaKey) || ''
    },

    recaptchaEnterprise () {
      return !!(this.$config && this.$config.recaptchaEnterprise)
    }
  },

  methods: {
    loadRecaptchaScript (onloadCallback = 'renderCaptcha') {
      if (this.recaptchaKey.length === 0 || typeof window.grecaptcha !== 'undefined') {
        return
      }

      const recaptchaScript = document.createElement('script')
      const scriptBase = this.recaptchaEnterprise
        ? 'https://www.google.com/recaptcha/enterprise.js'
        : 'https://www.google.com/recaptcha/api.js'

      const locale = this.$i18n && this.$i18n.locale
        ? this.$i18n.locale.split('-')[0]
        : 'en'

      recaptchaScript.setAttribute('src', `${scriptBase}?onload=${onloadCallback}&render=explicit&hl=${locale}`)
      recaptchaScript.setAttribute('defer', 'true')
      recaptchaScript.setAttribute('async', 'true')
      document.head.appendChild(recaptchaScript)
    },

    recaptchaApi () {
      if (!window.grecaptcha) return null
      return this.recaptchaEnterprise ? window.grecaptcha.enterprise : window.grecaptcha
    },

    renderRecaptcha (containerId = 'recaptcha', options = {}) {
      const api = this.recaptchaApi()
      if (this.recaptchaKey.length === 0 || !api) {
        return
      }

      try {
        this.recaptchaWidgetId = api.render(containerId, {
          sitekey: this.recaptchaKey,
          ...options
        })
      } catch (e) {
        console.warn('[reCAPTCHA] render error:', e)
      }
    },

    getRecaptchaResponse () {
      const api = this.recaptchaApi()
      if (!api) return ''
      return this.recaptchaWidgetId !== null
        ? api.getResponse(this.recaptchaWidgetId)
        : api.getResponse()
    },

    resetRecaptcha () {
      const api = this.recaptchaApi()
      if (!api) return
      this.recaptchaWidgetId !== null
        ? api.reset(this.recaptchaWidgetId)
        : api.reset()
    },

    async checkCaptchaStatus () {
      const action = this.captchaAction || 'login'
      try {
        const { data: shouldRenderCaptcha } = await Api.getV2(`captcha-status/${action}`, {
          skipAuth: true,
          skipCredentials: true
        })
        return shouldRenderCaptcha === true
      } catch (e) {
        return false
      }
    },

    async renderCaptcha () {
      if (this.recaptchaKey.length === 0) {
        return
      }
      if (!this.isCaptchaRendered) {
        const shouldRender = await this.checkCaptchaStatus()
        if (!shouldRender) {
          return
        }
        this.isCaptchaRendered = true
      }
      const containerId = this.captchaContainerId || 'recaptcha'
      if (this.recaptchaWidgetId !== null) {
        return
      }
      if (typeof window.grecaptcha !== 'undefined') {
        await this.$nextTick()
        this.renderRecaptcha(containerId)
      } else {
        this.loadRecaptchaScript('renderCaptcha')
      }
    },

    async renderRecaptchaCallback () {
      const containerId = this.captchaContainerId || 'recaptcha'
      await this.$nextTick()
      this.renderRecaptcha(containerId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/recaptcha.js